import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CustomMatPaginationService extends MatPaginatorIntl {
  private _ofLabel: string = 'sur';
  constructor(private _translateSrv: TranslateService) {
    super();
    this._redefinedStaticText();
    this._translateSrv.get('paginator.ofLabel').subscribe((response) => {
      this._ofLabel = response;
    });
  }

  private _redefinedStaticText(): void {
    const keys = [
      'paginator.nextPageLabel',
      'paginator.lastPageLabel',
      'paginator.previousPageLabel',
      'paginator.firstPageLabel',
      'paginator.itemsPerPageLabel',
    ];
    this._translateSrv.get(keys).subscribe((response) => {
      this.nextPageLabel = response[keys[0]];
      this.lastPageLabel = response[keys[1]];
      this.previousPageLabel = response[keys[2]];
      this.firstPageLabel = response[keys[3]];
      this.itemsPerPageLabel = response[keys[4]];
    });
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this._ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this._ofLabel} ${length}`;
  };
}
